/**
 * Created by tmorone on 2/8/2016.
 */

var App = require('../app.js');
var Backbone = require('backbone');
var Hash = require('../helpers/hash.js');

/**
 * A model to hold the definition of the quiz metadata.
 * Uses the server 'quiz' api.
 * Must be initialized with a collection id.
 */
module.exports = Backbone.Model.extend( {
    urlRoot: '/api/quiz/',
    /**
     * Override the fetch method to provide a success callback.
     * @param options
     */
    fetch: function(options) {
        Backbone.Model.prototype.fetch.call(this, {success: function() {

        }.bind(this), error: function(model,response,options) {
            App.Logger.debug(options.errorThrown);
        }});
    }
});